import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneAttachmentRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneAttachment";
        this.parentEnterpriseComponent = "ProjectPlanPhaseMilestone";
        this.childEnterpriseComponent = "ProjectPlanPhaseMilestoneAttachment";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanPhaseMilestoneUSID";
    }
}

export default ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneAttachmentRelationshipMetadata;